var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"item-text",style:(_vm.styles),on:{"click":_vm.onNavigation}},[_vm._v(_vm._s(_vm.detail.content))])
}
var staticRenderFns = []

export { render, staticRenderFns }